import ModalDialog from 'components/ModalDialog';
import React, { Fragment, useState } from 'react';

import CADetailModal from '../../CADashboard/CAList/CADetailModal';

interface Props {
  caId: number;
  isOpen: boolean;
  onClose?: () => void;
}

const AssetDetailsDialog: React.FC<Props> = ({ caId, isOpen, onClose }) => {
  const [isModalOpen, setIsModalOpen] = useState(isOpen);

  return (
    <Fragment>
      {isModalOpen && (
        <ModalDialog
          title="Host Asset Details"
          //   subTitle={rowData['name'] || ''}
          childComponent={<CADetailModal id={caId} />}
          onClose={() => {
            setIsModalOpen(false);
            onClose && onClose();
          }}
        />
      )}
    </Fragment>
  );
};

export default AssetDetailsDialog;
